import * as React from 'react';

import * as styles from './AppsList.css';
import { EAppService } from '../../../types/appService';

interface IAppsListProps {
  onDownloadAppClick(event: React.MouseEvent<HTMLAnchorElement>, appService: EAppService): void;
}

const appItems = [
  {
    name: EAppService.GooglePlay,
    href: 'https://cian-gp.onelink.me/v0bP/kqcg49a5',
    className: 'google-btn',
  },
  {
    name: EAppService.AppStore,
    href: 'https://cian-appstore.onelink.me/VnoK/pk9enmmo',
    className: 'apple-btn',
  },
  {
    name: EAppService.RuStore,
    href: 'https://cian-rustore.onelink.me/LwRA/pf5906mu',
    className: 'ru-store-btn',
  },
  {
    name: EAppService.AppGallery,
    href: 'https://cianag.onelink.me/LxJS/zsa0ui3o',
    className: 'app-gallery-btn',
  },
];

export const AppsList: React.FC<IAppsListProps> = ({ onDownloadAppClick }) => {
  return (
    <div className={styles['apps-list']} data-testid="apps-list">
      {appItems.map(item => (
        <a
          key={item.name}
          href={item.href}
          target="_blank"
          rel="nofollow noreferrer"
          className={styles[item.className]}
          onClick={event => onDownloadAppClick(event, item.name)}
        />
      ))}
    </div>
  );
};
